import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export type TAssignBusinessEntitiesToServiceRequestParams = {
  serviceRequestId: string;
  corporationIds: number[];
}

export type TAssignBusinessEntitiesToServiceRequestResponse = {
  serviceRequestCorporation: {
    corporationIds: number[];
  };
}

export const assignBusinessEntitiesToServiceRequest = async (
  params: TAssignBusinessEntitiesToServiceRequestParams
): Promise<Response> => {
  const { serviceRequestId, corporationIds } = params;

  return fetcher(
    `${API_BASE_PATH}/${serviceRequestId}/business-entities/assign`,
    {
      method: 'POST',
      body: { corporationIds },
    },
    undefined
  );
};
